
import { handler, HandlerBody, parseJson, parseMsDate } from '.';
import * as model from '../model';

async function taskHandlerRaw(body: HandlerBody, ucStatus = true) {
  return await handler('/Handlers/TaskItemHandler.ashx', body, ucStatus)
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
async function taskHandler<T>(body: HandlerBody, ucStatus = true) {
  return parseJson<T>(await taskHandlerRaw(body, ucStatus))
}

export interface Task {
  taskId: string
  createdAtUtc: string
  createdBy: string
  subject: string
  contactId: number
  stateId: number
  lookupId: string
  items: undefined
}

export interface TaskItem {
  itemId: string
  mediaTypeId: model.MediaType
  action: model.TaskItemAction
  dateTimeUtc: string
  subject: string
}

export async function getNewTask(myself: model.Identifier, itemId: string, contactId: string, mediaType: model.MediaType, medaiId: string, subject: string, action: model.TaskItemAction) {

  const task = parseJson(await taskHandlerRaw({
    command: 'add-task',
    extension: myself.id,
    servername: myself.server,
    data: contactId,
    data1: itemId,
    data2: mediaType,
    data3: subject,
    data4: medaiId,
    data5 : action.toString(),
  })) as Task

  return {
    taskId: task.taskId,
    createdAtUtc: parseMsDate(task.createdAtUtc),
    createdBy: myself.id,
    subject: task.subject,
    contactId: task.contactId,
    stateId: task.stateId,
    lookupId: task.lookupId,
    items: undefined,
  } as model.Task;
}

export async function deleteTask(myself: model.Identifier, taskId: string) {
  await taskHandlerRaw({
    command: 'delete-task',
    extension: myself.id,
    servername: myself.server,
    data: taskId,
  })
}

export async function updateTaskSubject(myself: model.Identifier, taskId: string, subject: string) {
  await taskHandlerRaw({
    command: 'update-task',
    extension: myself.id,
    servername: myself.server,
    data: taskId,
    data1: subject,
  })
}

export async function updateTaskState(myself: model.Identifier, taskId: string, stateId: number) {
  await taskHandlerRaw({
    command: 'update-task',
    extension: myself.id,
    servername: myself.server,
    data: taskId,
    data2: stateId.toString(),
  })
}

export async function addTaskItem(myself: model.Identifier, taskId: string, itemId: string, itemType: model.MediaType, itemSubject: string, action: model.TaskItemAction, medaiId: string) {
  return editTaskItem('add-item', myself, taskId, itemId, itemType, itemSubject, action, medaiId)
}

export async function updateTaskItem(myself: model.Identifier, taskId: string, itemId: string, itemType: model.MediaType, itemSubject: string, action: model.TaskItemAction, medaiId: string) {
  return editTaskItem('update-item', myself, taskId, itemId, itemType, itemSubject, action, medaiId)
}

async function editTaskItem(command: string, myself: model.Identifier, taskId: string, itemId: string, itemType: model.MediaType, itemSubject: string, action: model.TaskItemAction, medaiId: string) {
  const item = parseJson(await taskHandlerRaw({
    command: command,
    extension: myself.id,
    servername: myself.server,
    data: taskId,
    data1: itemId,
    data2: itemType,
    data3: itemSubject,
    data4: medaiId,
    data5: action.toString(),
  })) as TaskItem

  return {
    itemId: item.itemId,
    mediaTypeId: item.mediaTypeId,
    action: item.action,
    dateTimeUtc: parseMsDate(item.dateTimeUtc),
    subject: item.subject,
  } as model.TaskItem
}

export async function deleteTaskItem(myself: model.Identifier, taskId: string, itemId: string, itemType: model.MediaType, medaiId: string, action: model.TaskItemAction) {
  await taskHandlerRaw({
    command: 'delete-item',
    extension: myself.id,
    servername: myself.server,
    data: taskId,
    data1: itemId,
    data2: itemType,
    data3: medaiId,
    data4: action.toString(),
  })
}
